<!-- @format -->

<div class="choose-plan">
  <div ngbDropdown #dropdown="ngbDropdown">
    <h1 id="skip-link-target" tabindex="-1">
      <button
        type="button"
        ngbDropdownToggle
        class="non-button choose-plan__button"
        data-cy="choose-study-plan"
        [attr.aria-label]="(selectedPlan$ | async)?.name + ' ' + ('ARIA_LABEL.SELECT_PLAN' | translate)">
        <span class="row d-inline-flex">
          <span class="choose-plan__button__title">
            {{ (selectedPlan$ | async)?.name || ("STUDY_PLANS" | translate) }}
            <sis-tiny-badge *ngIf="(selectedPlan$ | async)?.primary" [variant]="'success'" data-cy="study-plan-primary-badge">
              {{ "PRIMARY_STUDY_PLAN" | translate }}
            </sis-tiny-badge>
          </span>
          <span class="choose-plan__button__icon">
            <sis-icon icon="chevron" iconClass="cw-90"></sis-icon>
          </span>
        </span>
      </button>
    </h1>
    <div ngbDropdownMenu class="multiple-line-items" role="menu">
      <ng-container *ngFor="let option of options$ | async">
        <span *ngIf="option.education" class="dropdown-header" role="heading">
          {{ option.education.name | localizedString }}
        </span>
        <button
          *ngIf="!option.education && option.plan"
          ngbDropdownItem
          role="option"
          data-cy="plan-select-button"
          (click)="onSelect(option.id); dropdown.close()"
          [attr.aria-current]="option.id === (selectedPlan$ | async)?.id"
          [class.active]="option.id === (selectedPlan$ | async)?.id">
          {{ option.plan.name }}
          <span *ngIf="option.id === (selectedPlan$ | async)?.id" class="visually-hidden">{{ "ARIA_LABEL.SELECTED" | translate }}</span>
          <sis-tiny-badge *ngIf="option.plan.primary" [variant]="'success'" data-cy="study-plan-primary-badge">
            {{ "PRIMARY_STUDY_PLAN" | translate }}
          </sis-tiny-badge>
          <span class="additional-data">
            <span *ngIf="option.selectedLearningOpportunityName">{{ option.selectedLearningOpportunityName | localizedString }}, </span>
            {{ option.curriculumPeriodName | localizedString }},
            {{ "STUDY_PLAN_MODIFIED" | translate: { modified: option.plan.metadata.lastModifiedOn | localDateFormat } }}
          </span>
        </button>
      </ng-container>
    </div>
    <div *ngIf="selectedPlan$ | async as selectedPlan" class="plan-description">
      {{ selectedPlanEducationName$ | async | localizedString }}
      (<ng-container *ngIf="selectedLearningOpportunityName$ | async as selectedLearningOpportunityName"
        >{{ selectedLearningOpportunityName | localizedString }},
      </ng-container>
      <ng-container *ngIf="selectedPlanCurriculumPeriodName$ | async as selectedPlanCurriculumPeriodName"
        >{{ selectedPlanCurriculumPeriodName | localizedString }},
      </ng-container>
      {{
        "STUDY_PLAN_MODIFIED_CREATED"
          | translate
            : {
                created: selectedPlan.metadata.createdOn | localDateFormat,
                modified: selectedPlan.metadata.lastModifiedOn | localDateFormat,
              }
      }})
    </div>
  </div>
</div>
